import {
  differenceInDays,
  eachDayOfInterval,
  eachWeekOfInterval,
  eachMonthOfInterval,
  format,
  sub
} from 'date-fns';
import { ReportDateRange } from '../types';

export const getIntervalDetails = (
  start: Date,
  end: Date
): { intervals: string[]; dateFormat: string } => {
  const difference = differenceInDays(end, start);

  let intervalDetails = { intervalFn: eachMonthOfInterval, dateFormat: 'MM/yyyy' };
  if (difference <= 30) {
    intervalDetails = { intervalFn: eachDayOfInterval, dateFormat: 'MM/dd/yyyy' };
  } else if (difference <= 85) {
    intervalDetails = { intervalFn: eachWeekOfInterval, dateFormat: 'MM/dd/yyyy' };
  }

  const { intervalFn, dateFormat } = intervalDetails;
  const intervals = intervalFn({ start, end }).map(date => format(date, dateFormat));

  return { intervals, dateFormat };
};

export const resolveDateRange = (
  reportDateRange: ReportDateRange,
  date = new Date()
): { dateStart: Date; dateEnd: Date } => {
  const [num, dateUnit] = reportDateRange.split('-');

  // To increase cache hit rate, we'll standardize the time values to stard/end of day.
  const endTime = new Date(date).setUTCHours(23, 59, 59, 999);
  const startTime = sub(new Date(date).setUTCHours(0, 0, 0, 0), {
    [dateUnit]: Number(num)
  }).getTime();

  return { dateStart: new Date(startTime), dateEnd: new Date(endTime) };
};
